export function LoadingDots({ className }) {
	return (
		<div className={`wpd-checkout-spinner ${className}`}>
			<div className="wpd-checkout-spinner-dot wpd-checkout-bounce1"></div>
			<div className="wpd-checkout-spinner-dot wpd-checkout-bounce2"></div>
			<div className="wpd-checkout-spinner-dot wpd-checkout-bounce3"></div>
		</div>
	);
}
